<section class="media-entry" role="button" tabindex="0" (click)="openModal()">
  <div class="media-entry__top">
    <div class="media-entry__icon">
      <i class="fa-solid fa-camera"></i>
    </div>

    <div class="media-entry__content">
      <h3>{{ title }}</h3>

      @if (photos.length === 0) {
        <p>Captura el estado visual del vehículo.</p>
      } @else {
        <p>{{ photos.length }} fotografías registradas</p>
      }
    </div>

    <div class="media-entry__arrow">
      <i class="fa-solid fa-chevron-right"></i>
    </div>
  </div>

  @if (photos.length > 0 && showMiniatures) {
    <div class="media-entry__preview">
      @for (photo of photos; track photo.previewUrl) {
        <figure>
          <img [src]="photo.previewUrl" alt="Evidencia recepción" />
        </figure>
      }
    </div>
  }
</section>

<dialog #modal class="reception-modal" (close)="onDialogClosed()">
    <article class="reception-modal__panel">
      <header class="reception-modal__header">
        <div>
          <h3>{{ title }}</h3>
          <span>{{ photos.length }} de {{ maxPhotos }} fotografías</span>
        </div>

        <button class="btn btn--ghost" type="button" (click)="closeModal()">
          Cerrar
        </button>
      </header>

      <div class="reception-modal__body">
        <app-photo-capture
          [minPhotos]="minPhotos"
          [maxPhotos]="maxPhotos"
          [initialPhotos]="photos"
          [fileNamePrefix]="fileNamePrefix"
          (photosChange)="onPhotosChanged($event)"
        />
      </div>
    </article>
</dialog>
